/** * 系统管理 角色管理 */
<template>
  <div>
    <div class="query-select">
      <el-form :inline="true" :model="queryParams" class="user-search">
        <el-form-item label="角色名称">
          <el-input
            v-model.trim="queryParams.roleName"
            placeholder="请输入角色名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="角色代码">
          <el-input
            v-model.trim="queryParams.roleKey"
            placeholder="请输入角色代码"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button plain round size="small"
          type="primary"
          icon="el-icon-search"
          @click="handleQuery"
          >查询</el-button
        >
        <el-button plain round size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="resetQuery"
          >重置</el-button
        >
        <!-- <el-button plain round size="small"
          type="success"
          icon="el-icon-plus"
          @click="dialogShow('add')"
          >新增</el-button
        > -->
      </div>
    </div>

    <div class="main-table">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        stripe
        header-cell-class-name="table-header"
        element-loading-text="拼命加载中"
        style="width: 100%;"
      >
        <el-table-column
          align="center"
          sortable
          prop="roleName"
          label="角色名称"
          min-width="160"
        >
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="roleKey"
          label="角色代码"
          min-width="160"
        >
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="createTime"
          label="创建时间"
          min-width="160"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.createTime }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="roleSort"
          label="排序"
          min-width="120"
        >
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="340">
          <template slot-scope="scope">
            <span v-if="isSuperAdminRole(scope.row)" class="role-op-disabled">
              —
            </span>
            <template v-else>
              <!-- <el-button plain round size="small"
                type="warning"
                @click="dialogShow('edit', scope.row)"
                >编辑</el-button
              > -->
              <el-button plain round size="small"
                type="primary"
                @click="menuAccess(scope.row)"
                >菜单权限</el-button
              >
              <!-- <el-button plain round size="small"
                type="danger"
                @click="deleteRole(scope.row)"
                >删除</el-button
              > -->
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pageparm.pageNum"
        :page-size="pageparm.pageSize"
        layout="total, prev, pager, next"
        :total="totals"
      >
      </el-pagination>
    </div>

    <RoleForm ref="formRef" @success="getList"></RoleForm>

    <Dialog
      title="菜单权限"
      :visible.sync="menuAccessshow"
      width="480px"
      :close-on-click-modal="false"
      @close="closeMenuDialog"
    >
      <div v-loading="menuLoading" class="menu-tree-wrap">
        <el-tree
          v-if="menuTreeVisible"
          ref="tree"
          :key="treeRenderKey"
          default-expand-all
          :data="roleRight"
          :props="roleRightProps"
          node-key="id"
          show-checkbox
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button plain round size="small" @click="closeMenuDialog">取消</el-button>
        <el-button plain round size="small"
          type="primary"
          :loading="menuSaving"
          @click="menuPermSave"
          >保存</el-button
        >
      </div>
    </Dialog>
  </div>
</template>

<script>
import {
  roleList,
  roleDelete,
  roleInfo,
  RoleRightTree,
  RoleRightSave
} from "@/api/system/role";
import { menuTreeSelect } from "@/api/system/menu";
import { loadUserPermissions } from "@/utils/permission";
import RoleForm from "./RoleForm.vue";

export default {
  components: {
    RoleForm
  },
  data() {
    return {
      loading: false,
      menuLoading: false,
      menuSaving: false,
      menuAccessshow: false,
      listData: [],
      totals: 0,
      queryParams: {
        roleName: "",
        roleKey: ""
      },
      pageparm: {
        pageNum: 1,
        pageSize: 10
      },
      roleRight: [],
      roleRightProps: {
        children: "children",
        label: "label"
      },
      saveroleId: "",
      menuTreeVisible: false,
      treeRenderKey: 0
    };
  },
  created() {
    this.getList();
  },
  methods: {
    isSuperAdminRole(row) {
      return row && row.roleKey === "admin";
    },
    async getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageparm.pageNum,
        pageSize: this.pageparm.pageSize,
        roleName: this.queryParams.roleName || undefined,
        roleKey: this.queryParams.roleKey || undefined
      };
      try {
        const result = await roleList(params);
        this.listData = (result.data && result.data.rows) || result.data || [];
        this.totals = (result.data && result.data.total) || result.count || 0;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    handleCurrentChange(val) {
      this.pageparm.pageNum = val;
      this.getList();
    },
    handleQuery() {
      this.pageparm.pageNum = 1;
      this.getList();
    },
    resetQuery() {
      this.queryParams = {
        roleName: "",
        roleKey: ""
      };
      this.pageparm.pageNum = 1;
      this.getList();
    },
    dialogShow(type, row = {}) {
      if (type === "edit" && this.isSuperAdminRole(row)) {
        this.$message.warning("超级管理员角色不允许操作");
        return;
      }
      this.$refs.formRef.open(type, row);
    },
    async deleteRole(row) {
      if (this.isSuperAdminRole(row)) {
        this.$message.warning("超级管理员角色不允许操作");
        return;
      }
      try {
        await this.$confirm("确定要删除吗?", "信息", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        await roleDelete(row.roleId);
        this.$message.success("删除成功");
        this.getList();
      } catch (e) {}
    },
    async menuAccess(row) {
      if (this.isSuperAdminRole(row)) {
        this.$message.warning("超级管理员角色不允许操作");
        return;
      }
      this.saveroleId = row.roleId;
      this.menuAccessshow = true;
      this.menuLoading = true;
      this.menuTreeVisible = false;
      this.roleRight = [];

      try {
        const [menuTreeRes, roleMenuRes] = await Promise.all([
          menuTreeSelect(),
          RoleRightTree(row.roleId)
        ]);
        const checkedKeys =
          (roleMenuRes.data && roleMenuRes.data.checkedKeys) || [];

        this.roleRight = menuTreeRes.data || [];
        this.treeRenderKey += 1;
        this.menuTreeVisible = true;
        this.menuLoading = false;

        await this.$nextTick();
        this.setRoleMenuChecked(checkedKeys);
      } catch (e) {
        this.menuAccessshow = false;
        this.menuLoading = false;
        this.menuTreeVisible = false;
      }
    },
    /**
     * 芋道标准回显：逐个 setChecked(id, true, false)
     * 不使用 setCheckedKeys(keys, true)，避免父节点误勾选全部子节点
     * 不使用 setCheckedKeys 批量回显，避免未勾选节点从树中消失
     */
    setRoleMenuChecked(checkedKeys) {
      const tree = this.$refs.tree;
      if (!tree) return;

      tree.setCheckedKeys([]);

      this.$nextTick(() => {
        (checkedKeys || []).forEach(menuId => {
          tree.setChecked(menuId, true, false);
        });
      });
    },
    async menuPermSave() {
      if (this.menuSaving) return;
      const checkedKeys = this.$refs.tree.getCheckedKeys();
      const halfCheckedKeys = this.$refs.tree.getHalfCheckedKeys();
      const menuIds = [...new Set([...halfCheckedKeys, ...checkedKeys])];
      this.menuSaving = true;
      try {
        const roleResult = await roleInfo(this.saveroleId);
        const roleData = roleResult.data || {};
        await RoleRightSave({
          roleId: this.saveroleId,
          roleName: roleData.roleName,
          roleKey: roleData.roleKey,
          roleSort: roleData.roleSort,
          status: roleData.status,
          menuIds
        });
        this.$message.success("权限保存成功");
        await loadUserPermissions(this);
        this.$root.Bus.$emit("menu-updated");
        this.closeMenuDialog();
      } catch (e) {
      } finally {
        this.menuSaving = false;
      }
    },
    closeMenuDialog() {
      this.menuAccessshow = false;
      this.menuTreeVisible = false;
      this.roleRight = [];
      this.saveroleId = "";
    }
  }
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.menu-tree-wrap {
  min-height: 200px;
  max-height: 420px;
  overflow-y: auto;
}
.role-op-disabled {
  color: #c0c4cc;
}
</style>



// WEBPACK FOOTER //
// src/views/system/Role/index.vue